import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useContext,
  useRef
} from "react";
import Link from "gatsby";
import styled, { ThemeProvider } from "styled-components";
import { Helmet } from "react-helmet";
import AOS from "aos";

import Header from "./Header";
import Footer from "./Footer";

import GlobalContext from "./../context/GlobalContext";

import GlobalStyle from "./../utils/globalStyle";

import { navigate } from "gatsby";
import { getProperty } from "./../utils/helperFn";
import "./../assets/fonts/fontawesome-5/webfonts/fa-brands-400.ttf";
import "./../assets/fonts/fontawesome-5/webfonts/fa-regular-400.ttf";
import "./../assets/fonts/fontawesome-5/webfonts/fa-solid-900.ttf";

import "./../assets/fonts/icon-font/fonts/avasta.ttf";
import "./../assets/fonts/icon-font/css/style.css";
import "./../../node_modules/aos/dist/aos.css";

import "./../assets/styles/bootstrap-custom.scss";
import "./../assets/styles/accordion.scss";
import "./../assets/styles/app.scss";

import "./../assets/fonts/icon-font/css/style.css";
import "./../assets/fonts/fontawesome-5/css/all.css";
import "./../assets/fonts/icomoon/style.css";

import { get, merge } from "lodash";

// the full theme object
import { theme as baseTheme } from "./../utils";
import { colors } from "../assets/styles/variables";

const domainGroupId = 'ecebf7c2-ecb8-4f9f-8fe6-65f1a6339773';

const Loader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999999999;
  opacity: 1;
  visibility: visible;
  transition: all 1s ease-out 0.5s;
  &.inActive {
    opacity: 0;
    visibility: hidden;
  }
`;

const StyledLink = styled.a`
  text-decoration: underine !important;
  color: #3b3b3b !important;
  &:hover {
    text-decoration: none !important;
  }  
`;

// options for different color modes
const modes = { light: "light", dark: "dark" };

// merge the color mode with the base theme
// to create a new theme object
const getTheme = (mode) =>
  merge({}, baseTheme, {
    colors: get(baseTheme.colors.modes, mode, baseTheme.colors),
  });

const Layout = ({ children, pageContext }) => {
  const gContext:any = useContext(GlobalContext);

  const [visibleLoader, setVisibleLoader] = useState(true);
  const [scrolled, setScrolled] = useState(false);

  const [headerReady, setHeaderReady] = useState(false);

  useLayoutEffect(() => {
    if(typeof window !== undefined){
      window.addEventListener("scroll", () => {
        setScrolled(window.scrollY > 300);
      });
      if (window.innerWidth > 1200) {
        AOS.init();
        document.getElementsByClassName('site-wrapper')[0].classList.add('desktop-device')
      } else {
        document.getElementsByClassName('site-wrapper')[0].classList.add('mobile-device')
      }

      // show after first paint
      requestAnimationFrame(() => setHeaderReady(true));

      setVisibleLoader(false);
    }
  }, []);

  // Navbar style based on scroll
  const eleRef = useRef(null);

  useEffect(() => {
    if(typeof window !== undefined){
      window.addEventListener(
        "popstate",
        function (event) {
          // The popstate event is fired each time when the current history entry changes.
          // gContext?.closeOffCanvas();
        },
        false
      );
      window.addEventListener(
        "pushState",
        function (event) {
          // The pushstate event is fired each time when the current history entry changes.
          // gContext?.closeOffCanvas();
        },
        false
      );
    }
  }, [gContext]);

  return (
    <>
      <Helmet>

        {/* Favicon main */}
        <link rel="icon" href="/favicon.ico" sizes="any"/>
        <link rel="icon" href="/favicon.svg" type="image/svg+xml"/>

        {/* Apple (iOS/iPadOS) */}
        <link rel="apple-touch-icon" sizes="167x167" href="/favicon-167x167.png"/>
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon-180x180.png"/>

        {/* PNG fallbacks */}
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>

        {/* PWA / Android */}
        <link rel="icon" type="image/png" sizes="192x192" href="/favicon-192x192.png"/>
        <link rel="icon" type="image/png" sizes="512x512" href="/favicon-512x512.png"/>

        <style type="text/css">{`
          #CybotCookiebotDialogPoweredbyLink {
            width: 100% !important;
            min-height: 3rem;
          }
          a#CybotCookiebotDialogPoweredbyCybot {
            display: none !important; 
          }
          .CybotCookiebotDialogDetailBodyContentCookieContainerButton {
            label { font-size: 15px !important; }
          }
          #CybotCookiebotDialog input:checked+.CybotCookiebotDialogBodyLevelButtonSlider {
            background-color: #e3406c !important;
          }
        `}</style>
      </Helmet>
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)     
        }
      >
        <GlobalStyle />
        <Loader id="loading" className={visibleLoader ? "" : "inActive"}>
          <div className="load-circle">
            <span className="one"></span>
          </div>
        </Loader>
        <div className={`site-wrapper overflow-hidden`} ref={eleRef}>
          <div style={{ visibility: headerReady ? "visible" : "hidden" }}>
            <Header isDark={gContext.headerDark} scrolled={scrolled} />
          </div>
          {children}
          <Footer isDark={gContext.footerDark} />
        </div>
        <div id="menu-portal-container"></div>
      </ThemeProvider>
    </>
  );
};

export default Layout;
